import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenService} from './token.service';
import {Injectable} from '@angular/core';
import {ApiRouteConfig} from '../../../config/api.route.config';
import {Environment} from "../../../environment/environment";

@Injectable()
export class AccountSiteService {

  private readonly redirectFragment = '&redirectUrl=' + window.location.href;
  private readonly applicationFragment = 'application=Building';
  private readonly loginPageFragment = 'login';
  private readonly signOutPageFragment = 'signout';
  private readonly dashboardPageFragment = 'dashboard';


  constructor(
      private httpClient: HttpClient,
      private tokenService: TokenService,
      private apiRouteConfig: ApiRouteConfig,
      private readonly environment: Environment,
  ) {
  }

  public goToLoginPage(redirect: boolean) {
    let url = `${this.environment.accountSiteUrl}${this.loginPageFragment}?${this.applicationFragment}`;
    if (redirect) {
      url += this.redirectFragment;
    }
    window.location.href = url;
  }

  public goToSignOutPage() {
    window.location.href = `${this.environment.accountSiteUrl}${this.signOutPageFragment}?${this.applicationFragment}`;
  }

  public goToDashboardPage() {
    window.location.href = `${this.environment.accountSiteUrl}${this.dashboardPageFragment}`;
  }

  public getApplications(): Observable<any[]> {
    const options = {
      headers: {
        'jwt': this.tokenService.getToken(),
        'refreshtoken': this.tokenService.getRefreshToken(),
      }
    };
    return this.httpClient.get<any[]>(this.apiRouteConfig.APPLICATIONS_ROUTE, options);
  }
}
